module.exports = __webpack_public_path__ + "img/icon-frig-2.8f978956.svg";